import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { INVOICE_NO_MAX_LENGTH } from '../constants/returnRequestConstants';

/**
 * İade talebi bilgileri bölümü
 */
const ReturnRequestInfoSection = ({ formData, errors, submitted, onInputChange, th, returnReasonTypes = [], loadingReasonTypes = false, showInvoiceNo = false }) => {
    const topRowColClass = showInvoiceNo ? 'col-12 md:col-4' : 'col-12 md:col-6';

    return (
        <>
            {/* İade Nedeni, İade Miktarı ve (yurt dışında) Fatura No */}
            <div className={topRowColClass}>
                <div className="field">
                    <label htmlFor="selectedReasonType">{th('dealerPartsReturnProcess.returnRequest.returnReasonType')} *</label>
                    <Dropdown
                        id="selectedReasonType"
                        value={formData.selectedReasonType}
                        options={returnReasonTypes}
                        onChange={(e) => onInputChange('selectedReasonType', e.value)}
                        optionLabel="label"
                        optionValue="value"
                        placeholder={th('dealerPartsReturnProcess.returnRequest.placeholders.returnReasonType')}
                        className={submitted && errors.selectedReasonType ? 'p-invalid w-full' : 'w-full'}
                        loading={loadingReasonTypes}
                        filter
                        showClear
                    />
                    {submitted && errors.selectedReasonType && <small className="p-error">{errors.selectedReasonType}</small>}
                </div>
            </div>

            <div className={topRowColClass}>
                <div className="field">
                    <label htmlFor="quantity">{th('dealerPartsReturnProcess.returnRequest.returnQuantity')} *</label>
                    <InputNumber
                        id="quantity"
                        value={formData.quantity}
                        onValueChange={(e) => onInputChange('quantity', e.value)}
                        className={submitted && errors.quantity ? 'p-invalid w-full' : 'w-full'}
                        placeholder={th('dealerPartsReturnProcess.returnRequest.placeholders.returnQuantity')}
                        min={0}
                    />
                    {submitted && errors.quantity && <small className="p-error">{errors.quantity}</small>}
                </div>
            </div>

            {showInvoiceNo && (
                <div className={topRowColClass}>
                    <div className="field">
                        <label htmlFor="invoiceNo">{th('dealerPartsReturnProcess.invoiceNo')} *</label>
                        <InputText
                            id="invoiceNo"
                            value={formData.invoiceNo}
                            onChange={(e) => onInputChange('invoiceNo', e.target.value)}
                            className={submitted && errors.invoiceNo ? 'p-invalid w-full' : 'w-full'}
                            placeholder={th('dealerPartsReturnProcess.returnRequest.placeholders.invoiceNo')}
                            maxLength={INVOICE_NO_MAX_LENGTH}
                        />
                        {submitted && errors.invoiceNo && <small className="p-error">{errors.invoiceNo}</small>}
                    </div>
                </div>
            )}

            {/* Arızalı Parça Checkbox */}
            <div className="col-12 md:col-6">
                <div className="field">
                    <div className="flex align-items-center">
                        <Checkbox id="isFaultyPart" checked={formData.isFaultyPart} onChange={(e) => onInputChange('isFaultyPart', e.checked)} />
                        <label htmlFor="isFaultyPart" className="ml-2">
                            {th('dealerPartsReturnProcess.returnRequest.isFaultyPart')}
                        </label>
                    </div>
                </div>
            </div>

            {/* Boş alan - grid layout için */}
            <div className="col-12 md:col-6"></div>

            {/* İade Açıklaması */}
            <div className="col-12">
                <div className="field">
                    <label htmlFor="returnDescription">{th('dealerPartsReturnProcess.returnRequest.returnDescription')}</label>
                    <InputTextarea
                        id="returnDescription"
                        value={formData.returnDescription}
                        onChange={(e) => onInputChange('returnDescription', e.target.value)}
                        className="w-full"
                        placeholder={th('dealerPartsReturnProcess.returnRequest.placeholders.returnDescription')}
                        rows={3}
                    />
                </div>
            </div>

            {/* Satır Açıklaması */}
            <div className="col-12">
                <div className="field">
                    <label htmlFor="lineDescription">{th('dealerPartsReturnProcess.returnRequest.lineDescription')}</label>
                    <InputTextarea
                        id="lineDescription"
                        value={formData.lineDescription}
                        onChange={(e) => onInputChange('lineDescription', e.target.value)}
                        className="w-full"
                        placeholder={th('dealerPartsReturnProcess.returnRequest.placeholders.lineDescription')}
                        rows={3}
                    />
                </div>
            </div>
        </>
    );
};

export default ReturnRequestInfoSection;
